module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAACCAYAAABR7VzxAAAAF0lEQVQImWP8////fwYKABMlmhkYGBgA/ZcEANzC67kAAAAASUVORK5CYII="